// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2DzoL","bigColWidth":"Table_bigColWidth__20YkG","biggerColWidth":"Table_biggerColWidth__ygzGs","row":"Table_row__2tHPi","col":"Table_col__1F98h"};